// extracted by mini-css-extract-plugin
module.exports = {"box":"_feedback-styles-module--box--2cj4E","graphic":"_feedback-styles-module--graphic--3_tsK","container":"_feedback-styles-module--container--1K-tK"};